module.exports = __webpack_public_path__ + "static/img/el-tenedor-rosa-2.60c17cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/el-tenedor-rosa-2.jpg
// module id = R9ky
// module chunks = 1